import React from "react";

// Admin Imports
import Operations from "views/admin/operations";
import Analytics from "views/admin/analytics";
import Orders from "views/admin/orders";
import SupplierQuotations from "views/admin/supplierQuotations";
import Offers from "views/admin/offers";
import Requests from "views/admin/requests";
import SupplierRequests from "views/admin/supplierRequests";
import Moqawelon from "views/admin/moqawelon";
import Suppliers from "views/admin/suppliers";
import Users from "views/admin/users";
import Admins from "views/admin/admins";
import Notifications from "views/admin/notifications";
import Support from "views/admin/support";
import Ads from "views/admin/ads";
import CommercialRegisterChangeRequests from "views/admin/commercialRegisterChangeRequests";
import AppContentEditor from "./views/admin/appContent";
import AdminContactsEditor from "./views/admin/adminContents";
import PaymentRequests from "views/admin/paymentRequests";
import SubscriptionPricing from "./views/admin/subscriptionPricing";
import Subscribers from "./views/admin/subscribers";
import SkillCategories from "views/admin/skillCategories";
// Auth Imports
import SignIn from "views/auth/SignIn";

// Icon Imports
import {
  MdHome,
  MdInsights,
  MdOutlineShoppingCart,
  MdLock,
  MdOutlineLocalOffer,
  MdGroupAdd,
  MdEngineering,
  MdAttachMoney,
  MdNotificationsActive,
  MdChat,
  MdChangeCircle,
  MdCategory,
} from "react-icons/md";
import { FaUsers, FaUserShield } from "react-icons/fa";
import { HiOutlineSpeakerphone } from "react-icons/hi";

// Sidebar groups in display order — each group is shown under its workspace.
export const GROUPS = {
  ops: { label: "العمليات" },
  catalog: { label: "الكتالوج" },
  content: { label: "المحتوى والتسويق" },
  billing: { label: "الفوترة" },
  governance: { label: "الإدارة" },
  analytics: { label: "التحليلات" },
};

const routes = [
  {
    name: "العمليات",
    layout: "/admin",
    path: "operations",
    workspace: "ops",
    group: "ops",
    icon: <MdHome className="h-6 w-6" />,
    component: <Operations />,
  },
  {
    name: "طلبات التسجيل",
    layout: "/admin",
    workspace: "ops",
    group: "ops",
    icon: <MdGroupAdd className="h-6 w-6" />,
    path: "register-requests",
    component: <Requests />,
  },
  {
    name: "طلبات تسجيل الموردين",
    layout: "/admin",
    workspace: "ops",
    group: "ops",
    icon: <MdGroupAdd className="h-6 w-6" />,
    path: "supplier-register-requests",
    component: <SupplierRequests />,
  },
  {
    name: "المدفوعات",
    layout: "/admin",
    workspace: "ops",
    group: "ops",
    path: "payments",
    icon: <MdAttachMoney className="h-6 w-6" />,
    component: <PaymentRequests />,
  },
  {
    name: "طلبات تغيير السجل التجاري",
    layout: "/admin",
    workspace: "ops",
    group: "ops",
    path: "commercial-register-change-requests",
    icon: <MdChangeCircle className="h-6 w-6" />,
    component: <CommercialRegisterChangeRequests />,
  },
  {
    name: "الشكاوي",
    layout: "/admin",
    workspace: "ops",
    group: "ops",
    path: "complaints",
    icon: <MdChat className="h-6 w-6" />,
    component: <Support />,
  },

  {
    name: "المستخدمين",
    layout: "/admin",
    workspace: "ops",
    group: "catalog",
    path: "users",
    icon: <FaUsers className="h-6 w-6" />,
    component: <Users />,
  },
  {
    name: "المقاولون",
    layout: "/admin",
    workspace: "ops",
    group: "catalog",
    path: "moqawelon",
    icon: <MdEngineering className="h-6 w-6" />,
    component: <Moqawelon />,
  },
  {
    name: "الموردون",
    layout: "/admin",
    workspace: "ops",
    group: "catalog",
    path: "suppliers",
    icon: <MdEngineering className="h-6 w-6" />,
    component: <Suppliers />,
  },
  {
    name: "الطلبات",
    layout: "/admin",
    workspace: "ops",
    group: "catalog",
    path: "orders",
    icon: <MdOutlineShoppingCart className="h-6 w-6" />,
    component: <Orders />,
    secondary: true,
  },
  {
    name: "طلبات تسعير الموردين",
    layout: "/admin",
    workspace: "ops",
    group: "catalog",
    path: "supplier-quotations",
    icon: <MdOutlineShoppingCart className="h-6 w-6" />,
    component: <SupplierQuotations />,
    secondary: true,
  },
  {
    name: "العروض",
    layout: "/admin",
    workspace: "ops",
    group: "catalog",
    path: "offers",
    icon: <MdOutlineLocalOffer className="h-6 w-6" />,
    component: <Offers />,
    secondary: true,
  },
  {
    name: "المهارات والتخصصات",
    layout: "/admin",
    workspace: "ops",
    group: "catalog",
    path: "skill-categories",
    icon: <MdCategory className="h-6 w-6" />,
    component: <SkillCategories />,
  },

  {
    name: "الاعلانات",
    layout: "/admin",
    workspace: "ops",
    group: "content",
    path: "ads",
    icon: <HiOutlineSpeakerphone className="h-6 w-6" />,
    component: <Ads />,
  },
  {
    name: "تعديل المحتوى",
    layout: "/admin",
    workspace: "ops",
    group: "content",
    path: "app-content",
    icon: <HiOutlineSpeakerphone className="h-6 w-6" />,
    component: <AppContentEditor />,
  },
  {
    name: "تعديل بيانات التواصل",
    layout: "/admin",
    workspace: "ops",
    group: "content",
    path: "admin-contacts",
    icon: <HiOutlineSpeakerphone className="h-6 w-6" />,
    component: <AdminContactsEditor />,
  },
  {
    name: "الاشعارات",
    layout: "/admin",
    workspace: "ops",
    group: "content",
    path: "notifications",
    icon: <MdNotificationsActive className="h-6 w-6" />,
    component: <Notifications />,
  },

  {
    name: "أسعار الاشتراكات",
    layout: "/admin",
    workspace: "ops",
    group: "billing",
    path: "subscription-pricing",
    icon: <MdAttachMoney className="h-6 w-6" />,
    component: <SubscriptionPricing />,
  },
  {
    name: "المشتركون",
    layout: "/admin",
    workspace: "ops",
    group: "billing",
    path: "subscribers",
    icon: <MdAttachMoney className="h-6 w-6" />,
    component: <Subscribers />,
  },

  {
    name: "المسؤولين",
    layout: "/admin",
    workspace: "ops",
    group: "governance",
    path: "admins",
    icon: <FaUserShield className="h-6 w-6" />,
    component: <Admins />,
    superAdminOnly: true,
  },

  {
    name: "نظرة عامة",
    layout: "/admin",
    workspace: "analytics",
    group: "analytics",
    path: "analytics",
    icon: <MdInsights className="h-6 w-6" />,
    component: <Analytics />,
  },

  {
    name: "تسجيل الدخول",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
];
export default routes;
